export default {
  isAtTheBottomOfThePage() {
    let bottomOfWindow = document.documentElement.scrollTop +
        window.innerHeight >= document.documentElement.scrollHeight

    // TODO(vignatti): I'm not sure the following conditional still aplies
    // after the tabs removal (commit 7f6cda7e).

    // When the user scrolls down a bit in one tab and, right after, switches
    // to another tab, v-tabs-items emits an unwanted v-scroll event. So, the
    // following snip is useful to catch this tricky corner case.
    if (!document.documentElement.scrollTop) {
      return false
    }

    if (bottomOfWindow)
      return true

    return false
  },
}
